import { BlockType, ComponentSettings, ContentSettings, DatasetField } from '@report-content';
import { ReportContentActions } from 'app/editor/report';

export abstract class AbstractComponentBuilder<T extends ComponentSettings> {
    constructor(
        protected contentSettings: ContentSettings,
        protected block: BlockType<T>,
        protected datasetFields: Array<DatasetField>,
        protected updateBlockSettings: (newSettings: ComponentSettings, options?: { shouldDirty?: boolean }) => void,
        protected actions: ReportContentActions,
    ) {
        if (this.shouldSyncFields()) {
            this.syncDatasetFields();
        }
    }

    public abstract getComponent(editPanel?: any): any;
    public abstract getEditPanel(): any;
    public getComponentControls(): any {
        return null;
    }
    // On DatasetFields update, sync the fields in the block settings if needed
    protected syncDatasetFields() {
        const currentFields = this.block.component.settings?.fields ?? [];
        const datasetFieldMap = new Map(this.datasetFields.map((f) => [f.reference_name, f]));
        const currentFieldSet = new Set(currentFields.map((f) => f.reference_name));

        const filteredFields = currentFields.filter((f) => datasetFieldMap.has(f.reference_name));
        const addedFields = this.datasetFields
            .filter((f) => !currentFieldSet.has(f.reference_name))
            .map((f) => this.makeField(f));

        const namesBefore = currentFields
            .map((f) => f.reference_name)
            .sort()
            .join(',');
        const namesAfter = [...filteredFields, ...addedFields]
            .map((f) => f.reference_name)
            .sort()
            .join(',');

        if (namesBefore != namesAfter) {
            this.updateBlockSettings({
                ...this.block.component.settings,
                fields: [...filteredFields, ...addedFields],
            } as T);
        }
    }
    // Override in builders that have fields in settings, e.g. dataset, pivot
    protected shouldSyncFields(): boolean {
        return false;
    }
    protected makeField<T>(f: DatasetField): T {
        return f as T;
    }
}
